const items = [
  "Asphalt Coring",
  "Concrete Coring",
  "Geotechnical Boring",
  "Soil Sampling",
  "Environmental Boring",
  "Utility Investigation",
  "Houston, Texas",
];

export default function Marquee() {
  return (
    <div className="bg-[#FF5A00] overflow-hidden py-4 border-y-4 border-[#0F172A]" data-testid="marquee-strip" aria-hidden="true">
      <div className="marquee-track flex whitespace-nowrap">
        {[0, 1].map((n) => (
          <div key={n} className="flex items-center shrink-0">
            {items.map((t) => (
              <span
                key={`${n}-${t}`}
                className="mx-6 flex items-center gap-12 font-heading text-xl sm:text-2xl font-black uppercase tracking-tight text-[#0F172A]"
              >
                {t}
                <span className="w-2.5 h-2.5 bg-[#0F172A] inline-block" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
